import { useContext, useEffect, useRef, useState } from 'react';
import { InterfaceContext } from '../store/InterfaceProvider';
import { getAllFeaturesInScaleYearAsCSV, getOneMapFeaturesCount, getOneMapFeaturesPageAsCSV, getAPageAsCSV } from '../requests/FeatureServiceRequests';
import { useAfterInit } from '../hooks/useAfterInit';
import CSVTable from '../utils/CSVTable';
import Pagination from './Pagination';
import DataDownloadLinks from './DataDownloadLinks';
import DataCdcgovLinks from './DataCdcgovLinks';
import Toggle from './Toggle';

const DataTable = () => {
    const { activeTimePeriod, activeScale, activeDataAttribute, setAppError, past12Months, activePast12Months, token } = useContext(InterfaceContext);
    const [csv, setCSV] = useState('');
    const tableSlugRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [currentPageNumber, setCurrentPageNumber] = useState(false);
    const [pageTotal, setPageTotal] = useState(0);
    const itemsPerPage = 1000;
    const [allowDataLookups, setAllowDataLookups] = useState(false);

    const handlePageChange = (pageIndex) => {
        setCurrentPageNumber(pageIndex);
    };
    const getTableData = ({ scale, time, attr, page = 0 }) => {
        const useFields = scale === 'usstate' ? 'name,period,' + attr : 'name,st_name,period,' + attr;
        const transformData = (obj) => {
            obj.period = activeTimePeriod === 'ttm' ? activePast12Months : activeTimePeriod;
            return obj;
        };
        getOneMapFeaturesPageAsCSV({ scale, time, page, pgCount: itemsPerPage, fields: useFields, transformFN: transformData, token })
            .then((data) => {
                setCSV(data);
                setLoading(false);
            })
            .catch((error) => {
                setCSV('');
                setLoading(false);
                setAppError(true, 'Data Table #3', error);
            });
    };
    useEffect(() => {
        if (!activePast12Months) return;
        if (!allowDataLookups) return;
        if (tableSlugRef.current !== activeTimePeriod + '_' + activeScale + '_' + activeDataAttribute) {
            setLoading(true);
            tableSlugRef.current = activeTimePeriod + '_' + activeScale + '_' + activeDataAttribute;

            getOneMapFeaturesCount(activeScale, activeTimePeriod, token)
                .then((count) => {
                    setPageTotal(count);
                })
                .catch((error) => {
                    setAppError(true, 'Data Table #1', error);
                    setPageTotal(0);
                });
            getTableData({
                scale: activeScale,
                time: activeTimePeriod,
                attr: activeDataAttribute,
                page: 0
            });
        }
    }, [activeTimePeriod, activeScale, allowDataLookups, activeDataAttribute, activePast12Months]);

    useAfterInit(() => {
        if (!activePast12Months) return;
        if (!allowDataLookups) return;
        setLoading(true);
        getTableData({
            scale: activeScale,
            time: activeTimePeriod,
            attr: activeDataAttribute,
            page: currentPageNumber
        });
    }, [currentPageNumber]);

    useEffect(() => {
        //Generate backup css, uncomment 1 at a time
        // getAllFeaturesInScaleYearAsCSV('census', 'ttm', token).then((csv) => {
        //     console.log(csv);
        //     console.log('↖ census ttm');
        // });
        // getAllFeaturesInScaleYearAsCSV('census', '2023', token).then((csv) => {
        //     console.log(csv);
        //     console.log('↖ census 2023');
        // });
        // getAllFeaturesInScaleYearAsCSV('census', '2022', token).then((csv) => {
        //     console.log(csv);
        //     console.log('↖ census 2022');
        // });
        // getAllFeaturesInScaleYearAsCSV('zcta', 'ttm', token).then((csv) => {
        //     console.log(csv);
        //     console.log('↖ zcta ttm');
        // });
        // getAllFeaturesInScaleYearAsCSV('zcta', '2023', token).then((csv) => {
        //     console.log(csv);
        //     console.log('↖ zcta 2023');
        // });
        // getAllFeaturesInScaleYearAsCSV('zcta', '2022', token).then((csv) => {
        //     console.log(csv);
        //     console.log('↖ zcta 2022');
        // });
        // getAPageAsCSV('zcta', '2022', token).then((csv) => {
        //     console.log('****CSV****');
        //     console.log(csv);
        // });
    }, []);

    return (
        <>
            <Toggle title={<h3>Data Table</h3>} onToggle={() => setAllowDataLookups(true)}>
                <div id="data-table" className={loading ? 'data-loading' : ''}>
                    <DataCdcgovLinks />
                    {/* <DataDownloadLinks allowLookups={allowDataLookups} /> */}
                    <CSVTable data={csv} />
                    <Pagination total={pageTotal} onChange={handlePageChange} itemsPerPage={itemsPerPage} />
                </div>
            </Toggle>
        </>
    );
};
export default DataTable;
